const PROMOTION_PRUNED_REFERENCES_NOTE = 'references not on the target were pruned' as const;

export default PROMOTION_PRUNED_REFERENCES_NOTE;
